import React from 'react';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer style={styles.footer}>
      <div style={styles.links}>
        <a href="/terms" target="_blank" rel="noopener noreferrer" style={styles.link}>Terms of Service</a>
        <a href="/privacy" target="_blank" rel="noopener noreferrer" style={styles.link}>Privacy Policy</a>
      </div>
      <p style={styles.text}>
        © {year} — Copyright by <strong>ZenQB</strong>. All rights reserved.
        <br />
        <em>Answers from AI may not be accurate. Please refer to your textbook for clarification.</em>
      </p>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: '#f9fafb',
    padding: '20px 0',
    textAlign: 'center',
    borderTop: '1px solid #e5e7eb',
    marginTop: '40px',
  },
  links: { marginBottom: '8px', fontSize: '14px' },
  link: { margin: '0 12px', color: '#6366f1', textDecoration: 'none', fontWeight: '500' },
  text: { margin: 0, fontSize: '13px', color: '#9ca3af', lineHeight: '1.6' },
};

export default Footer;
